import { rankWith, uiTypeIs, LayoutProps, Layout } from '@jsonforms/core';
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from '@jsonforms/react';
import { useState } from 'react';
import { CaretUpOutLined, CaretDownOutLined } from '../../../../../icons/truWeb-icons';
import {
  getControlsCount,
  getElements,
  getLabel,
} from '../../../../../utils/DynamicForms';
import { useDynamicFormContext } from '../../../DynamicFormContext';
import './style.scss';
type Props = LayoutProps;

const SectionLayout = (props: Props) => {
  const [isOpened, setIsOpened] = useState(true);
  const controlsCount = getControlsCount(props.uischema as Layout);
  const { formData } = useDynamicFormContext()

  if (!props.visible) return null;
  return (
    <div className={`tru-layout-Section tru-dynamic-form-wrapper tru-sub-section-header  ${formData?.stepNum === 3 ? 'section-header-font' : ''}`}>
      <div
        className="section-header-label"
        onClick={() => setIsOpened(!isOpened)}
      >
        <span>{getLabel(props.uischema)}</span>
        <span className={`arrow  ${!isOpened ? 'downArrow' : ''}`}>
          {<CaretUpOutLined />}
        </span>
      </div>
      <div
        className={!isOpened || !controlsCount ? 'collapsed-item' : ''}
        hidden={!isOpened || !controlsCount}
      >
        {getElements(props.uischema).map((element, index) => (
          <ResolvedJsonFormsDispatch
            {...props}
            uischema={element}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export const SectionLayoutEntry = {
  tester: rankWith(1, uiTypeIs('Section')),
  renderer: withJsonFormsLayoutProps(SectionLayout),
};
